import { Logo } from './Logo';

export const LoginBrand = () => {
  return (
    <div className="login-brand">
      <Logo size={52} className="login-brand-logo" />
      <div className="login-brand-text">
        <p className="login-brand-name">COENERGY</p>
        <p className="login-brand-tagline">ENERGIA POR ASSINATURA</p>
      </div>
    </div>
  );
};
